export class JsonToInt32 {
    static fromJson(json) {
        return json;
    }
    static toJson(value) {
        return value;
    }
    static fromAny(value) {
        return value;
    }
    static fromReact(e) {
        return e;
    }
}
JsonToInt32.default = 0;

export class JsonToInt64 {
    static fromJson(json) {
        return json;
    }
    static toJson(value) {
        return value;
    }
    static fromAny(value) {
        return value;
    }
    static fromReact(e) {
        return e;
    }
}
JsonToInt64.default = "0";

export class JsonToEnum {
    static fromJson(json) {
        return json;
    }
    static toJson(value) {
        return value;
    }
    static fromAny(value) {
        return value;
    }
    static fromReact(e) {
        return e;
    }
}
JsonToEnum.default = 0;

export class JsonToBoolean {
    static fromJson(json) {
        return json;
    }
    static toJson(value) {
        return value;
    }
    static fromAny(value) {
        return value;
    }
    static fromReact(e) {
        return e.target.checked;
    }
}
JsonToBoolean.default = false;

export class JsonToDouble {
    static fromJson(json) {
        return json;
    }
    static toJson(value) {
        return value;
    }
    static fromAny(value) {
        return value;
    }
    static fromReact(e) {
        return e;
    }
}
JsonToDouble.default = 0;

export class JsonToString {
    static fromJson(json) {
        return json;
    }
    static toJson(value) {
        return value;
    }
    static fromAny(value) {
        return value;
    }
    static fromReact(e) {
        return e.target.value;
    }
}
JsonToString.default = "";

export function JsonToList(json, converter) {
    if (!json) {
        return [];
    }
    const result = [];
    for (let i of json) {
        result.push(converter.fromJson(i));
    }
    return result;
}

export function ArrayToJson(list, converter) {
    if (list.length == 0) {
        return [];
    }
    const result = [];
    for (let i of list) {
        result.push(converter.toJson(i));
    }
    return result;
}

export function JsonToMap(json, key_converter, value_converter) {
    const result = {};
    for (let key in json) {
        result[key_converter.fromJson(key)] = value_converter.fromJson(json[key]);
    }
    return result;
}

export function MapToJson(map, key_converter, value_converter) {
    const result = {};
    for (let key in map) {
        result[key_converter.toJson(key)] = value_converter.toJson(map[key]);
    }
    return result;
}
